import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useState } from 'react';
import { REQUEST_NIAGA_BALANCE } from '../../queries/transactions';
import { useMutation } from '@apollo/client/react';
import { useAppDispatch } from '../../hooks/redux';
import { setSuccessMessage } from '../../store/messageSlice';

interface PayMeButtonProps {
  balanceSignature: string;
  totalDue: number;
  canRequestBalance: boolean;
  onSuccess?: () => void;
}

const PayMeButton = ({
  balanceSignature,
  totalDue,
  canRequestBalance,
  onSuccess,
}: PayMeButtonProps) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const dispatch = useAppDispatch();

  const [requestBalance, { loading }] = useMutation(REQUEST_NIAGA_BALANCE, {
    onCompleted: () => {
      setOpenConfirm(false);
      dispatch(setSuccessMessage('Payment requested successfully!'));
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error:any) => {
      console.error('Error requesting balance:', error);
      setOpenConfirm(false);
      // Error is now handled globally by Apollo error link
    },
  });

  const handleClickOpen = () => {
    setOpenConfirm(true);
  };

  const handleClose = () => {
    setOpenConfirm(false);
  };

  const handleConfirm = () => {
    console.log('balanceSignature', balanceSignature)
    requestBalance({
      variables: {
        input: {
          type: 'contract_payment',
          balance_signature: balanceSignature,
          amount: totalDue,
        },
      },
    });
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClickOpen}
        disabled={!canRequestBalance || loading}
      >
        Pay Me
      </Button>

      <Dialog
        open={openConfirm}
        onClose={handleClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">Confirm Payment Request</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to request payment of {totalDue.toLocaleString()} for your balance?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={loading} variant="contained" autoFocus>
            {loading ? 'Processing...' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PayMeButton;
